import { Col } from '@/app/components/Flex/Flex'
import { Lib } from '@/app/components/UI/Lib'
import { UI } from '@/app/components/UI/UI'
import { api } from '@/app/utils/api'
import { parseError } from '@/app/utils/error'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'

export const RemovePopup: FunctionalComponent<{
  id: string
  onClose: () => void
  onSuccess: () => void
}> = props => {
  const [errors, setErrors] = useState<string[]>([])
  const [loading, setLoading] = useState(false)

  return (
    <UI.Popup
      onClose={props.onClose}
    >
      <Lib.PopupHeader>
        Удалить совместимость?
      </Lib.PopupHeader>

      <Lib.PopupMessage>
        Страница совместимости будет удалена навсегда.
      </Lib.PopupMessage>

      <Lib.Errors errors={errors} />

      <Col grid gap={15}>
        <UI.Button
          size='m'
          type='secondary'
          disabled={loading}
          onClick={props.onClose}
        >
          Нет
        </UI.Button>
        <UI.Button
          size='m'
          type='primary'
          disabled={loading}
          onClick={async () => {
            setLoading(true)
            try {
              setErrors([])
              await api.delete(`/synastry/${props.id}`)
              props.onSuccess()
            }
            catch (e) {
              setErrors(parseError(e))
            }
            setLoading(false)
          }}
        >
          Удалить
        </UI.Button>
      </Col>
    </UI.Popup>
  )
}
